const paths = {
  home: "/",
  register: "/register",
  login: "/login",
  contacts: "/contacts",
};

export default paths;
